module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("chom2"))).then(() => parcelRequire('hEqeo'));